import styled, { keyframes } from 'styled-components';
import {
    colors,
    fontSizes, 
    fontWeights, 
    spacings,
    borders
} from 'styles/theme';

const fadeIn = keyframes`
  from {
    transform: scale(0);
  },
  to{
    transform: scale(1);
  }
`

export const TableFilters = styled.div`
  display: block;
  margin-bottom: ${spacings.ls};
  padding: 0px ${spacings.ls} ${spacings.ls} 0px;
  border-bottom: ${borders.xs} solid ${colors.neutral_light};
  
  .firstline{
    display: flex;
    align-items: center;
  }
  
  .secondline{
    display: flex;
    margin-top: 1.5rem;
  }

  .filter{
    display: flex;
    min-width: 120px;
    margin-right: 1rem;
  }

  strong{
    font-weight: ${fontWeights.w700};
    font-size: ${fontSizes.sl};
    color: ${colors.neutral_darkest};
    margin-right: ${spacings.md};
  }

  .btn-export{
    display: inline-flex;
    align-items: center;
    max-width: auto;
    height: 40px;
    padding: ${spacings.sl};
    border-radius: ${borders.md};
    border: ${borders.xs} solid ${colors.neutral_light};
    font-weight: ${fontWeights.w500};
    font-size: ${fontSizes.sm};
    color: ${colors.neutral_darkest};
    background-color: ${colors.white};
    animation: ${fadeIn} 0.2s linear;

    span{
      margin-left: ${spacings.xs}
    }
  }

  .data-result{
    display: inline-flex;
    margin-left: ${spacings.md};
  }

  > button{
    display: inline-flex;
    color: ${colors.neutral_darkest};
    min-width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    svg{
      transform: rotate(180deg);
    }

    &:hover {
      background-color: ${colors.neutral_regular};
      color: ${colors.neutral_darkest};
    }
  }

  .select-modified {
    width: auto;
  }
`